import { render, staticRenderFns } from "./InvoiceControls.vue?vue&type=template&id=b6d1cb02&"
import script from "./InvoiceControls.vue?vue&type=script&lang=js&"
export * from "./InvoiceControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports